import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What job roles are available in the Drone Engineering field?",
    
    description:
      "Drone Engineering offers roles like Drone Technician, UAV Designer, Flight Control Engineer, Drone Software Developer, Remote Pilot, GIS Specialist, and Autonomous Systems Engineer. Fields such as defense, agriculture, logistics, surveying, cinematography, and disaster management rely heavily on drone experts.",
  },
  {
    title: "What components will I learn to work with in Drone Engineering?",
    
    description:
      "You will work with brushless motors, ESCs, Li-Po batteries, GPS modules, IMU sensors, flight controllers like Pixhawk, propellers, transmitters, FPV systems, and communication modules. Learning how these components interact during flight is essential to drone engineering.",
  },
  {
    title: "Do I need a license to fly drones?",
   
    description:
      "In many countries, flying drones commercially or above certain weights requires certification. Students learn regulations from bodies like DGCA, FAA, or EASA, along with flight zones, safety protocols, and airspace rules to ensure legal drone operations.",
  },
  {
    title: "What tools and technologies are commonly used in drone development?",
   
    description:
      "Drone engineers use simulation tools like Gazebo and PX4, design software such as SolidWorks and Fusion 360, and microcontrollers like Arduino and Raspberry Pi. They also rely on LoRa, Wi-Fi, ROS, OpenCV, MAVLink, and QGroundControl for communication, testing, and development.",
  },
  {
    title: "What are the biggest challenges in Drone Engineering?",
    
    description:
      "Common drone engineering challenges include balancing weight and power, managing battery efficiency, ensuring stable flight, troubleshooting electronics, handling wind and environmental factors, maintaining reliable communication, and meeting strict safety and regulatory compliance requirements during real-world development.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
